import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-card-hsia-tags';
const html = `
<div class="container">
  <div data-attribute="wrap-card" data-bg-card="#f5f1ee" class="wrap-card" style="background-color: #f5f1ee;">
    <div data-attribute="card-left" data-order="1" class="card-left" style="order: 1">
      <div class="wrap-card-left">
        <div data-show="true" data-attribute="card-title" class="card-title">
         <h2 style="text-align:center;">Every Curve Deserves Comfort</h2>
        </div>
        <div
          data-show="true"
          data-attribute="list-tags"
          data-color-tag-item="#ffffff"
          data-bg-tag-item="#000000"
          data-color-hover-tag-item="#ffffff"
          data-bg-hover-tag-item="#a33333"
          class="list-tags"
          style="--color-tag-item: #ffffff; --bg-tag-item: #000000; --color-hover-tag-item: #ffffff; --bg-hover-tag-item: #a33333;"
        >
          <div class="wrap-list-tags">
            <a data-attribute="tag-item" href="#" class="tag-item">B CUP</a>
            <a data-attribute="tag-item" href="#" class="tag-item">D CUP</a>
            <a data-attribute="tag-item" href="#" class="tag-item">E CUP</a>
          </div>
        </div>
      </div>
    </div>
    <div data-attribute="card-right" data-order="2" class="card-right" style="order: 2">
      <div data-attribute="video-card" class="wrap-video" data-show-video="true" style="display: block;">
        <video
          data-attribute="video-item"
          src="https://www.hsialife.com/cdn/shop/videos/c/vp/21c0d9fe22f14dde97d071450cf30b96/21c0d9fe22f14dde97d071450cf30b96.HD-1080p-7.2Mbps-83484309.mp4?v=0"
          loop
          muted
          autoplay
          playsinline
        ></video>
      </div>
      <div data-attribute="image-card" class="wrap-image" data-show-image="false" style="display: none;">
        <img data-attribute="image-item" src="" alt="" />
      </div>
    </div>
  </div>
</div>
`;
export default containerFuild(html, css);
